import { render } from "./Approving.vue?vue&type=template&id=41d79b28"
import script from "./Approving.vue?vue&type=script&lang=js"
export * from "./Approving.vue?vue&type=script&lang=js"

import "./Approving.vue?vue&type=style&index=0&id=41d79b28&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__